export default __webpack_public_path__ + "static/media/illustration.fd780f80.png";